export default __webpack_public_path__ + "static/spot-testosterone-927a259dc335dadc69825b23b78ea4a5.jpg";